import React from "react";

import { useFormikContext } from "formik";
import { FaqQuestionPrefixEnum, NoOfFaqEnum } from "../../../../enums/template";
import { Template } from "../../../../models";

import SwitchContainer from "../common/SwitchContainer";

export default function IncludeFAQToggle() {
  const { values, setFieldValue } = useFormikContext<Partial<Template>>();

  return (
    <SwitchContainer
      title="Include FAQs"
      tooltip='Add a "Frequently Asked Questions" section to the bottom of the article.'
      enabled={Boolean(values?.includeFaq)}
      setEnabled={() => {
        setFieldValue("includeFaq", !values?.includeFaq);
        if (!values?.includeFaq && !values.faqQuestionPrefixId) {
          setFieldValue("faqQuestionPrefixId", FaqQuestionPrefixEnum.Q_LETTER);
        }
        if (!values?.includeFaq && !values.faqCount) {
          setFieldValue("faqCount", NoOfFaqEnum.THREE);
        }
      }}
    />
  );
}
